import React from "react";

export default function Footer() {
  return (
    <p
      style={{
        textAlign: "center",
        color: "rgb(107, 107, 107)",
        marginTop: "40px",
      }}
    >
      Copyright 2022 reserved &copy; Shivam Gupta
    </p>
  );
}
